import { Component, OnInit, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator, ControlValueAccessor } from '@angular/forms';
import { LocalizationService } from '../../services/localization.service';
import { PGUtilities } from '../../utilities/pg-utilities';

@Component({
    selector: 'app-pg-social',
    templateUrl: './pg-social.component.html',
    styleUrls: ['./pg-social.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PgSocialComponent),
            multi: true
        }, {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PgSocialComponent),
            multi: true,
        }],
    standalone: false
})
export class PgSocialComponent implements OnInit, ControlValueAccessor, Validator {
    @Input() fieldId:string;

    @Input() readonly:boolean;
    @Input() required:boolean;

    value:{ [social:string]: string } = null;

    socialList = ['facebook','instagram','youtube','tiktok'];

    constructor() { }

    ngOnInit() {
    }

    onValueChange() {
        if(this._onTouched != null) this._onTouched();
        if(this._onChange != null) this._onChange(JSON.stringify(this.value));
    }

    // INTERFACCIA ControlValueAccessor

    writeValue(obj:string) {
        this.value = PGUtilities.tryParseJSON(obj);
        if(this.value == null) this.value = {};
    }

    _onChange;

    registerOnChange(fn: any) {
        this._onChange = fn;
    }

    _onTouched;

    registerOnTouched(fn: any) {
        this._onTouched = fn;
    }

    // INTERFACCIA Validator

    validate()  {
        if(this.value == null || Object.keys(this.value).length == 0) {
            if(this.required) {
                return {
                    required: {
                        valid: false
                    }
                } 
            }
        }
    };
}
